module.exports = __webpack_public_path__ + "static/media/claudio.1449ebc0.jpeg";